angular.module('rjmNg.common.api').factory 'WarehouseConnections', [
  'AbstractConnections'
  (
    AbstractConnections
  ) ->

    PROPERTIES_TO_INCLUDE = [
      "database"
      "encryption_type"
      "host"
      "project_id"
      "project_name"
      "ssl"
      "status"
      "username"
    ]
    formatProperties = (properties) ->
      PROPERTIES_TO_INCLUDE.reduce (propertiesToInclude, name) ->
        propertiesToInclude[name] = properties?[name]
        propertiesToInclude
      ,
        port: if properties?.port? then "#{properties.port}"

    (clientId) ->
      pareModelFn = (model) ->
        preppedConn =
          name: model.name
          properties: formatProperties(model.properties)
          credentials: model.credentials
          type: model.type

        if model.properties.encryption_type is 'ssh'
          preppedConn.properties.encryption_username = model.properties.encryption_username
          preppedConn.properties.encryption_host = model.properties.encryption_host
          preppedConn.properties.encryption_port = model.properties.encryption_port

        return preppedConn

      AbstractConnections(clientId, "remote-data-warehouses", pareModelFn)

]
